import React, { useEffect, useState } from "react";
import { useShoppingContext } from "../context/ShoppingContext";
import DashboardButtons from "./DashboardButtons/DashboardButtons";
import MisGalpones from "../MisGalpones/MisGalpones";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import "../styles.css";

const Galpones = () => {
  const { galpones, fetchMisGalpones, isDarkMode } = useShoppingContext();

  const [highlightAddButton, setHighlightAddButton] = useState(false);

  useEffect(() => {
    fetchMisGalpones();
  }, [fetchMisGalpones]);

  const handleOnboardingClick = () => {
    setHighlightAddButton(true);
    setTimeout(() => {
      setHighlightAddButton(false);
    }, 6000); // Mantiene la señalización activa por 10 segundos
  };

  return (
    <div className={isDarkMode ? "content-container" : "content-container light"}>
      <DashboardButtons />

      {highlightAddButton && (
        <div className="highlight-message">
          <FontAwesomeIcon icon={faArrowUp} className="arrow-icon" />
          <span>Haz click arriba para añadir un galpón</span>
        </div>
      )}
      {galpones.length === 0 ? (
        <div className="onboarding-container">
          <h2 className="onboarding-header">
            Bienvenido a la gestión de galpones
          </h2>
          <p className="onboarding-text">
            Parece que aún no has creado ningún galpón. Empieza por aprender
            cómo hacerlo.
          </p>
          <button onClick={handleOnboardingClick} className="btn btn-secondary">
            Muéstrame cómo empezar
          </button>
        </div>
      ) : (
        <div className="section">
          <MisGalpones />
        </div>
      )}
    </div>
  );
};

export default Galpones;
